import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GOOGLE_SHEET_SYNC_FEATURE_KEY, GoogleSheetSyncState } from './google-sheet-sync.reducer';

// Lookup the 'GoogleSheetSync' feature state managed by NgRx
export const selectGoogleSheetSyncState = createFeatureSelector<GoogleSheetSyncState>(GOOGLE_SHEET_SYNC_FEATURE_KEY);

export const selectIsSyncing = createSelector(
  selectGoogleSheetSyncState,
  (state: GoogleSheetSyncState) => state.isSyncing
);

export const selectGoogleSheetSyncError = createSelector(
  selectGoogleSheetSyncState,
  (state: GoogleSheetSyncState) => state.error
);
